import React from 'react';
import FormStore from 'lib/stores/formStore';
import { get, destroy } from 'lib/request';
import CardEditFieldBtn from 'lib/base/Card/CardEditFieldBtn';

const ResidentDeleteAction = ({ resident, deleting, setDeleting }) => {
  const deleteResident = async e => {
    e.preventDefault();

    if (window.confirm('Are you sure you want to delete this resident?')) {
      setDeleting(true);
      await destroy(`/hosts/residents/${resident.id}`);
      const response = await get('/hosts/residents.json');

      setDeleting(false);
      FormStore.update(state => { state.residents = response.data; });
    }
  };

  return (
    <CardEditFieldBtn
      text=""
      aria_label="delete resident button"
      title="delete resident button"
      onClick={deleteResident}
      disabled={deleting}
      data_testid="deleteResidentButton"
      modifiers={['destructive']}
    />
  );
};

export default ResidentDeleteAction;
